export default "__VITE_ASSET__Dd6pMcUy__"